var map = {
	"./symbol_0.png": 77994,
	"./symbol_1.png": 33203,
	"./symbol_2.png": 58712,
	"./symbol_3.png": 26977,
	"./symbol_4.png": 90862,
	"./symbol_5.png": 33879,
	"./symbol_6.png": 49596,
	"./symbol_7.png": 62661,
	"./symbol_8.png": 32066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17101;